export function addCurrent(material) {
    return {
        type: 'ADD_CURRENT',
        material,
    }
}
